import styled from "styled-components";

import { WebsiteTypeFilter } from "pro-features/components/filtersPanel/src/WebsiteTypeFilter";
import type { ITableFilters } from "app/components/React/Table/types";
import { SearchAndUtils } from "app/components/React/table-top/SearchAndUtils";
import { resolveExcelLink } from "app/components/React/TopSites/DomainsTable/TableTop";
import { getSelectedCategory } from "app/pages/industry-analysis/common/getSelectedCategory";
import { getPlayersQueryParams } from "app/pages/industry-analysis/players/table/fetchData";
import type { WebsiteTypeOption } from "app/pages/keyword-analysis/Organic";
import { allTrackers } from "app/services/track/track";

const FiltersContainer = styled.div`
    padding: 10px;
    height: 32px;
`;

export interface PlayersTableFilters extends ITableFilters {
    websiteType: WebsiteTypeOption;
}

interface ITableTop {
    excelEndpoint: string;
    tableFilters: PlayersTableFilters;
    setTableFilters: (tableFilters: PlayersTableFilters) => void;
    columns: Array<unknown>;
    onClickToggleColumns: (field: string) => void;
}

export const TableTop = ({
    excelEndpoint,
    tableFilters,
    setTableFilters,
    columns,
    onClickToggleColumns,
}: ITableTop) => {
    const { sort, search, websiteType } = tableFilters;
    const category = getSelectedCategory();
    const params = {
        ...getPlayersQueryParams(),
        category: category.text,
        ...(websiteType && { funcFlag: websiteType.id }),
    };
    const excelLink = resolveExcelLink(excelEndpoint, params, sort);

    const onSearchChange = (search) => {
        setTableFilters({ ...tableFilters, search });
        allTrackers.dispatchTrackEvent("Search Bar", "Change", `Table Search Bar`, { search });
    };

    const setWebsiteType = (websiteType) => {
        setTableFilters({ ...tableFilters, websiteType });
        const websiteForTracking = websiteType ? websiteType.text : "All Website Types";
        allTrackers.dispatchTrackEvent("Filter Table", "select", "Website Type", {
            ["Website Type"]: websiteForTracking,
        });
    };

    const onCloseWebsiteTypeItem = () => setWebsiteType(undefined);
    return (
        <>
            <FiltersContainer>
                <WebsiteTypeFilter
                    websiteType={websiteType?.text}
                    onWebsiteTypeItemClick={setWebsiteType}
                    onCloseWebsiteTypeItem={onCloseWebsiteTypeItem}
                />
            </FiltersContainer>
            <SearchAndUtils
                search={search}
                onSearchChange={onSearchChange}
                onClickToggleColumns={onClickToggleColumns}
                tableColumns={columns}
                excelLink={excelLink}
            />
        </>
    );
};
